/*
  Showroom hub — Request Pricing form.
  Posts JSON to the quote-request-public Supabase Edge Function so the lead
  lands in quote_requests -> dashboard /admin/quote-requests as an Organic lead.

  Payload contract: keep in sync with
  arctic-spas-ops-dashboard/supabase/functions/quote-request-public/index.ts
  (STRING_KEYS whitelist; unknown keys are rejected with 400 bad_keys).
    city         = the showroom city (section setting), NOT the customer's town
    postal_code  = optional customer postal code
    landing_page = this page's canonical URL (organic attribution)
    form         = 'showroom-pricing' default; ad / sauna pages set data-form-tag
    intent       = data-intent on the form ('buy_spa' | 'buy_sauna'); the page is
                   the intent on these forms, so no chooser (quote_requests.intent)
    selections   = [{ section: 'Notes', items: [{ label, value }] }] for free text

  Shopify renders forms with novalidate, so required fields are enforced here
  via reportValidity() (theme CLAUDE.md "Theme JS gotchas").
*/
(function () {
  'use strict';

  var FORM_TAG = 'showroom-pricing';

  function utm(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function canonicalUrl() {
    var link = document.querySelector('link[rel="canonical"]');
    return (link && link.href) || (window.location.origin + window.location.pathname);
  }

  function buildPayload(form) {
    var f = function (name) {
      var el = form.elements[name];
      return el ? String(el.value || '').trim() : '';
    };
    var payload = {
      name: f('name'),
      email: f('email'),
      phone: f('phone'),
      postal_code: f('postal_code'),
      model: f('model'),
      city: form.getAttribute('data-city') || '',
      landing_page: canonicalUrl(),
      referrer: document.referrer || '',
      utm_source: utm('utm_source'),
      utm_medium: utm('utm_medium'),
      utm_campaign: utm('utm_campaign'),
      // Ad landing pages name themselves (data-form-tag="lp-hot-tubs-kitchener").
      form: form.getAttribute('data-form-tag') || FORM_TAG,
      website: f('website') // honeypot; humans leave it empty
    };
    var intent = form.getAttribute('data-intent');
    if (intent) payload.intent = intent;
    var notes = f('notes');
    payload.selections = notes
      ? [{ section: 'Notes', items: [{ label: 'Notes', value: notes.slice(0, 300) }] }]
      : [];
    return payload;
  }

  function show(el, text) {
    if (!el) return;
    if (text !== undefined) el.textContent = text;
    el.hidden = false;
    try { el.focus(); } catch (e) { /* noop */ }
  }

  function hide(el) {
    if (el) el.hidden = true;
  }

  function messageFor(error) {
    switch (error) {
      case 'invalid_email':
        return 'Please check your email address and try again.';
      case 'missing_location':
        return 'Please add your postal code so we know which showroom is closest.';
      case 'rate_limited':
        return 'Too many requests from this connection. Please try again in an hour, or call the showroom.';
      default:
        return 'Sorry — we could not send your request. Please try again, or call the showroom number below.';
    }
  }

  function wire(form) {
    var endpoint = form.getAttribute('data-endpoint');
    var okEl = form.querySelector('[data-form-ok]');
    var errEl = form.querySelector('[data-form-error]');
    var submitBtn = form.querySelector('[data-form-submit]');
    if (!endpoint) return;

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      hide(okEl);
      hide(errEl);

      // Enforce required fields — the theme renders forms with novalidate.
      var required = form.querySelectorAll('[required]');
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checkValidity()) {
          required[i].reportValidity();
          return;
        }
      }

      var payload = buildPayload(form);
      var originalLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            return { status: res.status, data: data };
          });
        })
        .then(function (r) {
          if (r.status === 200 && r.data && r.data.ok) {
            form.reset();
            show(okEl);
            return;
          }
          show(errEl, messageFor(r.data && r.data.error));
        })
        .catch(function () {
          show(errEl, messageFor('network'));
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-showroom-hub-form]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
